import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { Dispatch } from 'redux';
import releaseAnnouncementActions from '../../Actions/releaseAnnouncementActions';
import useModal from '../../Hooks/useModal';
import Modals from '../../Constants/modals';
import ReleaseAnnouncementBanner from './ReleaseAnnouncementBanner';
import ReleaseAnnouncementModal from './ReleaseAnnouncementModal';
import type { RootState } from './Announcement.types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyDispatch = Dispatch<any>;

const ReleaseAnnouncementManager = () => {
    const dispatch: AnyDispatch = useDispatch();
    const { openModal, isModalOpen } = useModal();
    const major = useSelector((state: RootState) => state.AnnouncementReducer.major);
    const minor = useSelector((state: RootState) => state.AnnouncementReducer.minor);

    const majorId = major?.id;
    useEffect(() => {
        if (majorId !== undefined) {
            openModal(Modals.ReleaseAnnouncement);
        }
    }, [majorId, openModal]);

    const closeMajor = (remindLater: boolean) => {
        const id = major?.id;
        if (id === undefined) {
            return;
        }
        dispatch(remindLater ? releaseAnnouncementActions.snooze(id) : releaseAnnouncementActions.acknowledge(id));
    };

    const dismissMinor = () => {
        const id = minor?.id;
        if (id !== undefined) {
            dispatch(releaseAnnouncementActions.acknowledge(id));
        }
    };

    return (
        <>
            {major === null && minor !== null && <ReleaseAnnouncementBanner announcement={minor} onClose={dismissMinor} />}
            {major !== null && isModalOpen(Modals.ReleaseAnnouncement) && <ReleaseAnnouncementModal announcement={major} onClose={closeMajor} />}
        </>
    );
};

export default ReleaseAnnouncementManager;
